// extracted by mini-css-extract-plugin
export default {"editor":"reward-config-editor_editor__hpf+C","formContainer":"reward-config-editor_formContainer__h8nRX"};